import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}